module.exports = __webpack_public_path__ + "static/media/65.0b495245.jpg";